import React from 'react'
import { components } from 'react-select'

import { Select, Flex, Icon } from 'components/common'
import { useI18n } from '~/core/i18n'

const languageOptions = [
  {
    label: 'English',
    value: 'en'
  },
  {
    label: 'Czech',
    value: 'cz'
  },
  {
    label: 'German',
    value: 'de'
  }
]

const selectStyles = {
  control: provided => ({
    ...provided,
    border: 0,
    cursor: 'pointer',
    minHeight: 35,
    fontSize: 14,
    width: 120
  }),
  menu: provided => ({
    ...provided,
    zIndex: 999999,
    textAlign: 'left'
  }),
  indicator: provided => ({
    ...provided,
    cursor: 'pointer'
  }),
  indicatorSeparator: provided => ({
    ...provided,
    display: 'none'
  })
}

const CustomSingleValue = ({ children, ...props }) => (
  <components.SingleValue {...props}>
    <Flex alignCenter>
      <Icon icon="globe" style={{ margin: 0 }} />
      <span>{children}</span>
    </Flex>
  </components.SingleValue>
)

const LanguageSelect = () => {
  const [msg, currentLanguage, setLanguage] = useI18n()
  return (
    <Select
      components={{ SingleValue: CustomSingleValue }}
      isSearchable={false}
      options={languageOptions}
      styles={selectStyles}
      value={languageOptions.find(option => option.value === currentLanguage) || null}
      onChange={({ value }) => setLanguage(value)}
    />
  )
}

export { LanguageSelect }
